// validation.js
export const validateCard = (cashInfo) => {
  const errors = {};

  if (!cashInfo.name) {
    errors.name = "Il nome è obbligatorio";
  }

  if (!cashInfo.cardNumber || cashInfo.cardNumber.length !== 16) {
    errors.cardNumber = "Numero della carta non valido";
  }

  if (
    !cashInfo.expiryDate ||
    !/^(0[1-9]|1[0-2])\/\d{2}$/.test(cashInfo.expiryDate)
  ) {
    errors.expiryDate = "Data di scadenza non valida (MM/YY)";
  }

  if (!cashInfo.cvv || cashInfo.cvv.length !== 3) {
    errors.cvv = "CVV non valido";
  }

  return errors;
};
